import {
    LIST_INHIBITION_TYPES,
    LIST_INHIBITION_TYPES_SUCCESS,
    LIST_INHIBITION_TYPES_ERROR,
    ADD_INHIBITION_TYPES,
    SAVE_INHIBITION_TYPES,
    SAVE_INHIBITION_TYPES_SUCCESS,
    SAVE_INHIBITION_TYPES_ERROR,
    DELETE_INHIBITION_TYPES,
    DELETE_INHIBITION_TYPES_SUCCESS,
    DELETE_INHIBITION_TYPES_ERROR,
    EDIT_INHIBITION_TYPES,
    UPDATE_INHIBITION_TYPES,
    UPDATE_INHIBITION_TYPES_SUCCESS,
    UPDATE_INHIBITION_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import inhibitionTypesData from '../data/inhibitionTypes';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'inhibicion-tipo';

//LISTAR INHIBITION TYPES
export function listInhibitionTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listInhibitionTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const inhibitionTypes = response.data;
            //const inhibitionTypes = inhibitionTypesData;
            //Llamo al dispatch
            dispatch( listInhibitionTypesSuccess(inhibitionTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listInhibitionTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listInhibitionTypes = () => ({
    type: LIST_INHIBITION_TYPES,
    payload: true
});

const listInhibitionTypesSuccess = inhibitionTypes => ({
    type: LIST_INHIBITION_TYPES_SUCCESS,
    payload: inhibitionTypes
});

const listInhibitionTypesError = error => ({
    type: LIST_INHIBITION_TYPES_ERROR,
    payload: error
});

//ADD INHIBITION TYPE
export function addInhibitionTypesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addInhibitionTypes(false) );
        //Abro el formulario
        showForm();
    }
}

const addInhibitionTypes = isEdit => ({
    type: ADD_INHIBITION_TYPES,
    payload: isEdit
});

//SAVE INHIBITION TYPE
export function saveInhibitionTypesAction(inhibitionType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveInhibitionTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, inhibitionType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveInhibitionTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveInhibitionTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveInhibitionTypes = () => ({
    type: SAVE_INHIBITION_TYPES,
    payload: true
});


const saveInhibitionTypesSuccess = inhibitionType => ({
    type: SAVE_INHIBITION_TYPES_SUCCESS,
    payload: inhibitionType
});

const saveInhibitionTypesError = error => ({
    type: SAVE_INHIBITION_TYPES_ERROR,
    payload: error
});

//EDIT INHIBITION TYPE
export function editInhibitionTypesAction(inhibitionType, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editInhibitionTypes(inhibitionType) );
        //Abro el formulario
        showForm();
    }
}

const editInhibitionTypes = inhibitionType => ({
    type: EDIT_INHIBITION_TYPES,
    payload: inhibitionType
});

//UPDATE INHIBITION TYPE
export function updateInhibitionTypesAction(inhibitionType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateInhibitionTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${inhibitionType.id}`, inhibitionType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateInhibitionTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateInhibitionTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateInhibitionTypes = () => ({
    type: UPDATE_INHIBITION_TYPES,
    payload: true
});

const updateInhibitionTypesSuccess = inhibitionType => ({
    type: UPDATE_INHIBITION_TYPES_SUCCESS,
    payload: inhibitionType
});

const updateInhibitionTypesError = error => ({
    type: UPDATE_INHIBITION_TYPES_ERROR,
    payload: error
});

//DELETE INHIBITION TYPE
export function deleteInhibitionTypesAction(inhibitionType) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteInhibitionTypes() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${inhibitionType.id}`);
            const response = await clienteAxios.put(`/${controller}/${inhibitionType.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteInhibitionTypesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteInhibitionTypesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteInhibitionTypes = () => ({
    type: DELETE_INHIBITION_TYPES,
    payload: true
});

const deleteInhibitionTypesSuccess = inhibitionType => ({
    type: DELETE_INHIBITION_TYPES_SUCCESS,
    payload: inhibitionType
});

const deleteInhibitionTypesError = error => ({
    type: DELETE_INHIBITION_TYPES_ERROR,
    payload: error
});